import { MenuItem } from '@mui/material';
import { CustomSelectAndChildren } from '../../../../../components/CustomSelectAndChildren';
import { CustomTextField } from '../../../../../components/CustomTextField';
import { MealTypeEnum } from '../Model/Model';
import { CustomAddMediumChip } from '../../../../../components/CustomAddMediumChip';
import React from "react";

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const SetUp = ({
    allCafeterias,
    allItem,
    allMeals,
    disabled,
    emptyFields,
    handleChange,
    item,
    mealTime,
    t,
    isValidCost,
    validateCost,
    selectedMealTime,
    setSelectedMealTime,
    setMealTime,
    notSelected,
    showCostInfo
}) => {

    return (
        <div className='mb-3'>
            <CustomSelectAndChildren
                id='slt_su_dish'
                name='dish'
                trans='meal'
                disabled={disabled}
                value={item.dish}
                onChange={handleChange}
                emptyFields={emptyFields}
                showNoSelectionOption={false}
                required={true}
            >
                {allItem?.map((meal) => (
                    <MenuItem key={meal.id} value={meal.id}>
                        {t(meal.name)}
                    </MenuItem>
                ))}
            </CustomSelectAndChildren>
            <CustomSelectAndChildren
                id='slt_su_meal_type'
                name='mealType'
                trans='meal_type'
                disabled={disabled}
                onChange={handleChange}
                emptyFields={emptyFields}
                value={item.mealType}
                showNoSelectionOption={false}
                required={true}
            >
                {allMeals?.map((meal) => (
                    <MenuItem key={meal.id} value={meal.id}>
                        {t(MealTypeEnum[meal.id]?.name || '')}
                    </MenuItem>
                ))}
            </CustomSelectAndChildren>

            <CustomSelectAndChildren
                id='slt_su_diner'
                name='diner'
                trans='diner'
                disabled={disabled}
                onChange={handleChange}
                emptyFields={emptyFields}
                value={item.diner}
                required={true}
                showNoSelectionOption={false}
            >
                {allCafeterias?.map((meal) => (
                    <MenuItem key={meal.id} value={meal.id}>
                        {t(meal.name)}
                    </MenuItem>
                ))}
            </CustomSelectAndChildren>

            { showCostInfo &&
                <CustomTextField
                    id='txt_su_cost'
                    name='cost'
                    trans="meal_cost"
                    type='number'
                    required={true}
                    onChange={(e)=>{
                        handleChange(e);
                        validateCost(e);
                    }}
                    suffixText={<p className={"ibl-font-w-600 text-uppercase"}>$</p>}
                    inputProps={{
                        min: 1
                    }}
                    showCounter={true}
                    length={3}
                    value={item.cost}
                    emptyFields={emptyFields}
                    isValid={isValidCost}
                    isValidText={"this_value_must_be_greater_than_0"}
                    helperText={"this_value_must_be_greater_than_0"}
                />
            }
            <CustomAddMediumChip
                autocompleteId='slt_su_service_time'
                buttonId='btn_su_service_time'
                disabled={disabled}
                required={true}
                label={'service_time'}
                typeUnit={'stock'}
                transUnit='stock'
                unitLength={3}
                data={mealTime}
                selectedList={selectedMealTime}
                setSelectedList={setSelectedMealTime}
                onSelectItem={(item) => setMealTime((prev) => ({ ...prev, item }))}
                onChangeUnit={(unit) => setMealTime((prev) => ({ ...prev, unit }))}
                emptyFields={notSelected && emptyFields}
            />
        </div>
    );
};

export default SetUp;
